define(function (require) {
    "use strict";

    var _ = require("underscore");
    var LE = require("app");
    var template = require("user-management-templates/users/userWithProfilesEdit.tmpl");
    var ProfileBubbleView = require("user-management-views/users/UserEditProfileBubbleView");
    var PictureUrlBubbleView = require("user-management-views/users/UserEditPictureUrlBubbleView");
    var AuthDetailsBubbleView = require("user-management-views/users/UserEditAuthDetailsBubbleView");
    var UserEditMaxConversationsAccountView = require("user-management-views/users/UserEditMaxConversationsAccountView");
    var UserEditMaxConversationsCustomView = require("user-management-views/users/UserEditMaxConversationsCustomView");

    var RadioButtonList = require("ui/radio-button-list/RadioButtonList");
    var InputField = require("ui/input-field/InputField");
    var Dropdown = require("ui/dropdown/Dropdown");
    var ToggleButton = require("ui/toggle-button/toggleButton");
    var Multiselect = require("ui/multiselect/Multiselect");
    var Button = require("ui/button/Button");
    var Bubble = require("ui/bubble/Bubble");
    var SingleSelect = require("ui/singleselect-new/Singleselect");

    var ProfileModel = require("models/entities/ProfileModel");
    var RETYPE_PASSWORD_ERROR_KEY = "retypePassword";

    var UserWithProfilesEditView = {};

    var MAX_CONVERSATIONS_TYPE = {
        ACCOUNT_SETTINGS: 0,
        CUSTOM_SETTINGS: 1
    };

    var IS_API_USER_KEYS = {
        PASSWORD: 0,
        API: 1
    };

    var API_KEY_MODEL_PRIVILEGE = {
        data:"api.user.login",
        type: "API"
    };

    var CREATE_API_KEY_ID = 0;

    var URLS = {
        AVATAR_PICTURE:  window.leImageBaseUrl + "src/modules/user-management/assets/img/avatar200x200.png",
        BOT_PICTURE:  window.leImageBaseUrl + "src/modules/user-management/assets/img/botAvatar.png",
        BROKEN_URL_PICTURE: window.leImageBaseUrl + "src/modules/user-management/assets/img/broken-image.png"
    };

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        UserWithProfilesEditView = Marionette.ItemView.extend({
            className: "user-edit",
            template: template,
            ui:{
                userTypeContainer: ".user-type-container",
                userType: ".user-type-container .input-container",
                userTypeIcon: ".user-type-container .icon",
                loginName: ".login-name-container .input-container",
                email: ".email-container .input-container",
                nickName: ".nick-name-container .input-container",
                displayName: ".display-name-container .input-container",
                employeeId: ".employee-id-container .input-container",
                profile: ".profile-container .input-container",
                profileIcon: ".profile-container .icon",
                enabled: ".enabled-container .input-container",
                maxChatsContainer: ".max-chats-container",
                maxChats: ".max-chats-container .input-container",
                maxConversationsContainer: ".max-conversations-container",
                maxConversationRadioButtonList: ".max-conversations-container .max-conversation-radio-button-list",
                maxConversations: ".max-conversations-container .input-container",
                skillsContainer: ".skills-container",
                skills: ".skills-container .input-container",
                skillsMismatch: ".skills-container .mismatch-icon",
                lobsContainer: ".lobs-container",
                lobs: ".lobs-container .input-container",
                currentPasswordSection: ".current-password-container",
                currentPassword: ".current-password-container .input-container",
                newPassword: ".new-password-container .input-container",
                retypePassword: ".retype-password-container .input-container",
                changePasswordContainer: ".change-password-container",
                changePasswordNextLogin: ".change-password-container .input-container",
                cancelButton: ".cancel-button",
                saveButton: ".save-button",
                memberOfSelect: ".member-of-select",
                memberOfSelectContainer: ".member-of-select-container",
                memberOfInputField: ".member-of-select-container .input-field",
                managerOfSelect: ".manager-of-select",
                managerOfSelectContainer: ".manager-of-select-container",
                pictureUrlInput: ".picture-url-container .input-container",
                pictureUrlIcon: ".picture-url-container .icon",
                picturePreview: ".picture-preview-container img",
                employeeIdContainer: ".employee-id-container",
                settingsSectionContainer: ".settings-section-container",
                isApiUserSubSectionContainer: ".login-method-sub-section-container",
                isApiUserContainer: ".login-method-container",
                isApiUser: ".login-method-container .input-container",
                passwordSubSectionContainer: ".password-sub-section-container",
                apiSubSectionContainer: ".api-sub-section-container",
                apiSubSectionIcon: ".api-sub-section-container .icon",
                apiKeysDropdownContainer: ".api-key-dropdown-container .dropdown-container",
                apiDetailsContainer: ".api-details-container",
                appKey: ".app-key-container .value-container",
                appSecret: ".secret-container .value-container",
                accessToken: ".token-container .value-container",
                accessTokenSecret: ".token-secret-container .value-container",
                apiErrorIcon: ".api-key-dropdown-container .error"
            },
            uiComponents: {
                loginName: {
                    type: InputField,
                    options: {
                        el: "view.ui.loginName",
                        permutation: InputField.Permutation.B,
                        placeholder: LE.translator.translate("LEUserManagement.userEdit.loginName.placeholder.new")
                    },
                    events: {
                        change: "_onLoginNameChange"
                    }
                },
                email: {
                    type: InputField,
                    options: {
                        el: "view.ui.email",
                        permutation: InputField.Permutation.B,
                        placeholder: LE.translator.translate("LEUserManagement.userEdit.email.placeholder")
                    },
                    events: {
                        change: "_onEmailChange"
                    }
                },
                nickName: {
                    type: InputField,
                    options: {
                        el: "view.ui.nickName",
                        permutation: InputField.Permutation.B,
                        placeholder: LE.translator.translate("LEUserManagement.userEdit.nickName.placeholder")
                    },
                    events: {
                        change: "_onNickNameChange"
                    }
                },
                displayName: {
                    type: InputField,
                    options: {
                        el: "view.ui.displayName",
                        permutation: InputField.Permutation.B,
                        placeholder: LE.translator.translate("LEUserManagement.userEdit.displayName.placeholder")
                    },
                    events: {
                        change: "_onDisplayNameChange"
                    }
                },
                employeeId: {
                    type: InputField,
                    options: {
                        el: "view.ui.employeeId",
                        permutation: InputField.Permutation.B,
                        maxLength: "view.modelValidators.maxEmployeeIdLength",
                        placeholder: LE.translator.translate("LEUserManagement.userEdit.employeeId.placeholder")
                    },
                    events: {
                        change: "_onEmployeeIdChange"
                    }
                },
                pictureUrl: {
                    type: InputField,
                    options: {
                        el: "view.ui.pictureUrlInput",
                        permutation: InputField.Permutation.B,
                        maxLength: "view.modelValidators.maxPictureUrlLength",
                        placeholder: LE.translator.translate("LEUserManagement.userEdit.pictureUrl.placeholder")
                    },
                    events: {
                        onblur: "_onPictureUrlBlur",
                        change: "_onPictureUrlChange"
                    }
                },
                memberSingleSelect: {
                    type: SingleSelect,
                    options: {
                        container: "view.ui.memberOfSelect",
                        permutation: SingleSelect.PERMUTATION.B,
                        theme: SingleSelect.THEME.DEFAULT,
                        errorPosition: SingleSelect.ERROR_POSITION.RIGHT,
                        inputField: {
                            placeholder: LE.translator.translate("LEUserManagement.userEdit.assignedToGroup.placeholder")
                        },
                        items : "view._getGroupsItems"
                    }
                },
                enabled: {
                    type: ToggleButton,
                    options: {
                        container: "view.ui.enabled",
                        transition: ToggleButton.TRANSITION.FAST
                    },
                    events: {
                        "toggleButton:change": "_onEnabledChange"
                    }
                },
                maxChats: {
                    type: Dropdown,
                    options: {
                        name: "maxChats",
                        container: "view.ui.maxChats",
                        permutation: Dropdown.PERMUTATION.MEDIUM,
                        testCollision: true,
                        items: "view._getMaxChatsItems"
                    },
                    events: {
                        change: "_onMaxChatsChange"
                    }
                },
                skills: {
                    type: Multiselect,
                    options: {
                        container: "view.ui.skills",
                        permutation: Multiselect.PERMUTATION.MEDIUM,
                        trim: true,
                        list: {
                            newItem: {
                                visible: true,
                                value: LE.translator.translate("LEUserManagement.userEdit.skills.create.label")
                            }
                        },
                        tagsContainer: {
                            placeholder: LE.translator.translate("LEUserManagement.userEdit.skills.placeholder"),
                            tagMaxWidth: "275px"
                        },
                        items: "view._getSkillsItems"
                    },
                    events: {
                        create: "_onSkillsCreate",
                        select: "_onSkillsChange",
                        unselect: "_onSkillsChange"
                    }
                },
                manageGroups: {
                    type: Multiselect,
                    options: {
                        container: "view.ui.managerOfSelect",
                        permutation: Multiselect.PERMUTATION.MEDIUM,
                        trim: true,
                        list: {
                            noItems: {
                                visible: true,
                                value: LE.translator.translate("LEUserManagement.userEdit.manageGroups.noItems.placeholder")
                            }
                        },
                        tagsContainer: {
                            placeholder: LE.translator.translate("LEUserManagement.userEdit.manageGroups.placeholder"),
                            inlineErrorText: LE.translator.translate("LEFramework.entities.user.errors.assignToGroup.notFromList"),
                            tagMaxWidth: "275px",
                            maxShownLines: 2
                        },
                        items: "view._getAgentGroups"
                    },
                    events: {
                        //create: "_onManagerCreate",
                        select: "_onManagerChange",
                        unselect: "_onManagerChange"
                    }
                },

                newPassword: {
                    type: InputField,
                    options: {
                        el: "view.ui.newPassword",
                        permutation: InputField.Permutation.B,
                        type: InputField.Type.Password,
                        placeholder: "view._getPasswordPlaceholder"
                    },
                    events: {
                        change: "_onNewPasswordChange"
                    }
                },
                retypePassword: {
                    type: InputField,
                    options: {
                        el: "view.ui.retypePassword",
                        permutation: InputField.Permutation.B,
                        type: InputField.Type.Password
                    },
                    events: {
                        change: "_onRetypePasswordChange"
                    }
                },
                cancelButton: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButton",
                        permutation: Button.PERMUTATION.LINK
                    },
                    events: {
                        "click": "_onCancel"
                    }
                },
                saveButton: {
                    type: Button,
                    options: {
                        el: "view.ui.saveButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        "click": "_onSave"
                    }
                },
                changePasswordNextLogin: {
                    type: ToggleButton,
                    options: {
                        container: "view.ui.changePasswordNextLogin",
                        transition: ToggleButton.TRANSITION.FAST
                    },
                    events: {
                        "toggleButton:change": "_onChangePasswordNextLoginChange"
                    }
                }
            },
            events: {
                "mouseenter @ui.pictureUrlIcon": "_showPictureUrlBubble",
                "mouseleave @ui.pictureUrlIcon": "_closePictureUrlBubble",
                "mouseenter @ui.profileIcon": "_showProfileBubble",
                "mouseleave @ui.profileIcon": "_closeProfileBubble",
                "mouseenter @ui.userTypeIcon": "_showUserTypeBubble",
                "mouseleave @ui.userTypeIcon": "_closeUserTypeBubble",
                "mouseenter @ui.apiSubSectionIcon": "_showAuthBubble",
                "mouseleave @ui.apiSubSectionIcon": "_closeAuthBubble",
                "mouseenter @ui.apiErrorIcon": "_showApiErrorBubble",
                "mouseleave @ui.apiErrorIcon": "_closeApiErrorBubble"
            },

        modelEvents: {
                "change": "_onModelChange",
                "change:allowedAppKeys": "_updateApiKeyDetails"
            },

            URLS: URLS,

            //<editor-fold desc="Marionette-Functions">
            /*-----------------------------------------------------------------------------------------------*/
            initialize: function(options) {
                this._initialize(options);
            },
            onRender: function() {
                this._onRender();
            },
            updatePictureUrl: function() {
                this._updatePictureUrl();
            },
            //</editor-fold>

            //<editor-fold desc="publicFunctions">
            /*-----------------------------------------------------------------------------------------------*/
            validateView: function() {
                return this._validateView();
            },
            //</editor-fold>


            //<editor-fold desc="privateFunctions">
            /*-----------------------------------------------------------------------------------------------*/
            _initialize: function(options) {
                options = options || {};
                this.model = options.model;
                this.modelValidators = this.model.MODEL_VALIDATORS;
                this.channel = LEUserManagement.media.channel(LEUserManagement.channels.USER_EDIT);

                this.isMyUser = options.isMyUser;
                this.skillsCollection = LEUserManagement.getDataManager().getSkillsCollection();
                this.agentGroupsCollection =  LEUserManagement.getDataManager().getAgentGroupsCollection();
                this.initMemberAndManagerOfFields = options.memberAndManagerOfStatus;
                this.isEmployeeIdFieldHidden = options.employeeIdStatus;
                this.showMaxConversations = options.showMaxConversations || false;
                this.hasTaggingByLobFeatureEnabled = LE.sessionManager.hasEntitiesTaggingByLobFeature();
                this.maxConversationsSettings = options.maxConversationsSettings;
                this.hasAgentUserEditPrivilege = LEUserManagement.hasAgentUserEditPrivilege() || LEUserManagement.hasAllUsersViewPrivilege();
                this.hasAgentManagerUserEditPrivilege = LEUserManagement.hasAgentManagerUserEditPrivilege() || LEUserManagement.hasAllUsersViewPrivilege();
                this.prevSkills = [];
                this.apiKeysCollection = new Backbone.Collection();
                this._initProfiles(options);
            },

            _onRender: function() {
                this._bindEvents();
                this._renderLobConfiguration();
                this._renderUserType();
                this._renderIsApiUser();
                this._updateIsApiUser();
                this._renderCurrentPassword();
                this._updateLoginName();
                this._updateEmail();
                this._updateNickName();
                this._updateDisplayName();
                this._manageEmployeeIdStatus();
                this._updatePictureUrl();
                this._renderProfiles();
                this._updateEnabled();
                this._updateMaxChats();
                this._renderMaxConversationsRadioButtonList();
                this._checkMemberAndManagerOfFieldStatus();
                this._onProfileChange();
                this._updateSaveButtonState();
                this._updateChangePasswordNextLogin();
                this._updateSkillsMismatch();
                this._setFocus();
            },

            _bindEvents: function() {
                this.listenTo(this.channel.vent, "user:skill:create:success", this._onSkillCreateSuccess);
                this.listenTo(this.channel.vent, "user:skill:create:error", this._onSkillCreateError);
                this.listenTo(this.channel.vent, "user:save:success", this._onSaveSuccess);
                this.listenTo(this.channel.vent, "user:save:error", this._onSaveError);
                this.listenTo(this.channel.vent, "user:change:userType", this._updatePictureUrl);
                this.listenTo(this.channel.vent, "user:change:userType", this._updateIsApiUser);
                this.listenTo(this.channel.vent, "user:change:isApiUser", this._updateIsApiUser);
                this.listenTo(this.channel.vent, "user:apiModel:save:success", this._onApiCreateSuccess);
                this.listenTo(this.channel.vent, "user:apiModel:save:error", this._onApiCreateError);
                if (LE.sessionManager.hasUserTypeBotFeature() && LE.sessionManager.hasPrivilege(LE.sessionManager.PRIVILEGES.VIEW_API_KEYS_MANAGEMENT)) {
                    this.listenToOnce(LEUserManagement.getDataManager().getApiKeysCollection(), "fetch:success", this._updateApiKeysCollection);
                }
            },

            _initProfiles: function(options) {
                this.profilesCollection =  LEUserManagement.getDataManager().getProfilesCollection();
            },

            _renderLobConfiguration: function() {
                if (this.hasTaggingByLobFeatureEnabled) {
                    this.ui.lobsContainer.removeClass("hide");

                    if (!this.uiComponents.lobs) {
                        this.uiComponents.host$.createAndRender("lobs", {
                            type: Multiselect,
                            options: {
                                container: "view.ui.lobs",
                                permutation: Multiselect.PERMUTATION.MEDIUM,
                                trim: true,
                                list: {
                                    noItems: {
                                        visible: true,
                                        value: LE.translator.translate("LEUserManagement.userEdit.lobs.noItems.text")
                                    }
                                },
                                tagsContainer: {
                                    placeholder: LE.translator.translate("LEUserManagement.userEdit.lobs.placeholder"),
                                    inlineErrorText: LE.translator.translate("LEUIComponents.errors.tagscontainer.viewValidation.selectFromList"),
                                    tagMaxWidth: "275px",
                                    maxShownLines: 2
                                },
                                items: "view._getLobsItems"
                            },
                            events: {
                                select: "_onLobsChange",
                                unselect: "_onLobsChange"
                            }
                        });
                    }
                }
            },

            _renderIsApiUser: function() {
                if (LE.sessionManager.hasUserTypeBotFeature() && LE.sessionManager.hasPrivilege(LE.sessionManager.PRIVILEGES.VIEW_API_KEYS_MANAGEMENT)) {
                    if (!this.uiComponents.isApiUser) {
                        this.uiComponents.host$.createAndRender("isApiUser", {
                            type: Dropdown,
                            options: {
                                container: "view.ui.isApiUser",
                                permutation: Dropdown.PERMUTATION.MEDIUM,
                                items: "view._getIsApiUserItems",
                                selectedOption: "view._getSelectedIsApiUser",
                                placeholder: LE.translator.translate("LEUserManagement.userEdit.loginMethod.placeholder")
                            },
                            events: {
                                change: "_onIsApiUserChange"
                            }
                        });
                    }

                    if (!this.uiComponents.apiKeysDropdown) {
                        this.uiComponents.host$.createAndRender("apiKeysDropdown", {
                            type: Dropdown,
                            options: {
                                container: "view.ui.apiKeysDropdownContainer",
                                permutation : Dropdown.PERMUTATION.MEDIUM,
                                customItem: "view._getApiKeyCustomItem",
                                items : "view._getApiKeysCollection",
                                selectedOption: "view._getSelectedApiKey",
                                collectionMap: {
                                    key: "keyId",
                                    value: "appName"
                                },
                                enabled: "view._getApiKeysDropdownState",
                                placeholder: LE.translator.translate("LEUserManagement.userEdit.apiKeys.dropdown.placeholder"),
                                listenToCollectionChanges: true
                            },
                            events: {
                                change: "_onApiKeyChange"
                            }
                        });
                    }
                }
            },

            _renderCurrentPassword: function() {
                if (this.isMyUser) {
                    this.ui.currentPasswordSection.removeClass("hide");
                    this.uiComponents.host$.createAndRender("currentPassword", {
                        type: InputField,
                        options: {
                            el: "view.ui.currentPassword",
                            permutation: InputField.Permutation.B,
                            type: InputField.Type.Password,
                            placeholder: LE.translator.translate("LEUserManagement.userEdit.currentPassword.placeholder")
                        },
                        events: {
                            change: "_onCurrentPasswordChange"
                        }
                    });
                }
            },

            _renderProfiles: function() {
                var dataManager = LEUserManagement.getDataManager();
                var roleGroupOrder = dataManager.getProfilesRolesGroupOrder();
                this.uiComponents.host$.createAndRender("profile", {
                    type: Multiselect,
                    options: {
                        container: "view.ui.profile",
                        permutation: Multiselect.PERMUTATION.MEDIUM,
                        trim: true,
                        items: "view._getProfilesArray",
                        list: {
                            groupsOrder: roleGroupOrder,
                            singleSelectPerGroup: true
                        },
                        tagsContainer: {
                            placeholder: LE.translator.translate("LEUserManagement.userEdit.profiles.placeholder"),
                            inlineErrorText: LE.translator.translate("LEUIComponents.errors.tagscontainer.viewValidation.selectFromList"),
                            separator: LE.translator.translate("LEUserManagement.userEdit.profiles.separator"),
                            tagMaxWidth: "320px"
                        }
                    },
                    events: {
                        "select": "_onProfileSelect",
                        "unselect": "_onProfileUnSelect"
                    }
                });
            },

            _updateIsApiUser: function() {
                if (LE.sessionManager.hasUserTypeBotFeature()) {
                    var  isTypeBot = (this.uiComponents.userType.getValue() === this.model.USER_TYPES.BOT);
                    var isApiUserSelectedValue = null;
                    if (this.uiComponents.isApiUser) {
                        isApiUserSelectedValue = this.uiComponents.isApiUser.getValue();
                    }
                    var hasPrivilegeToEditBotAuthentication = LE.sessionManager.hasPrivilege(LE.sessionManager.PRIVILEGES.VIEW_API_KEYS_MANAGEMENT);
                    var showPasswordMethod = !isTypeBot || (hasPrivilegeToEditBotAuthentication && (isApiUserSelectedValue === IS_API_USER_KEYS.PASSWORD));
                    var showApiMethod = isTypeBot && hasPrivilegeToEditBotAuthentication && isApiUserSelectedValue === IS_API_USER_KEYS.API;
                    this.ui.isApiUserSubSectionContainer.toggleClass("hide", !isTypeBot);
                    this.ui.passwordSubSectionContainer.toggleClass("hide", !showPasswordMethod);
                    this.ui.apiSubSectionContainer.toggleClass("hide", !showApiMethod);
                    this.ui.settingsSectionContainer.toggleClass("hide", !hasPrivilegeToEditBotAuthentication && isTypeBot);
                    if (showApiMethod) {
                        this._updateApiKeyDetails();
                    }
                }
            },

            _getSelectedIsApiUser: function() {
                var value = null;
                if (!this.model.isNew()){
                    value = this.model.getIsApiUser() ? IS_API_USER_KEYS.API : IS_API_USER_KEYS.PASSWORD;
                }
                return value;
            },

            _checkMemberAndManagerOfFieldStatus: function() {
                this.manageMemberOfFieldStatus(this.initMemberAndManagerOfFields.showMemberField);
                this.manageManagerOfFieldStatus(this.initMemberAndManagerOfFields.showManagerOfField);
            },

            _manageEmployeeIdStatus: function () {
                this.employeeIdStatus(this.isEmployeeIdFieldHidden);
                if(!this.isEmployeeIdFieldHidden){
                    this.uiComponents.employeeId.setValue(this.model.getEmployeeId());
                }
            },

            customTemplateHelpers: function () {
                return {
                    hasProfiles: this._hasProfiles
                };
            },

            manageMaxChatsStatus: function(status) {
                if (status) {
                    this.ui.maxChatsContainer.removeClass("hide");
                } else {
                    this.ui.maxChatsContainer.addClass("hide");
                }
                this.uiComponents.maxChats.setEnabled(this.hasAgentUserEditPrivilege);
            },

            manageMaxConversationsStatus: function(status) {
                if (this.showMaxConversations) {
                    if (status) {
                        this.ui.maxConversationsContainer.removeClass("hide");
                    }
                    else {
                        this.ui.maxConversationsContainer.addClass("hide");
                    }
                    this.uiComponents.maxConversationRadioButtonList.setEnableAll(this.hasAgentUserEditPrivilege);
                }
            },

            manageSkillsStatus: function(status) {
                if (status) {
                    _.each(this.prevSkills, _.bind(function(skill) {
                        this.uiComponents.skills.select(skill);
                    }, this));
                    this.prevSkills = [];
                } else {
                    if (_.isEmpty(this.prevSkills)) {
                        this.prevSkills = this.uiComponents.skills.getSelectedItems();
                    }
                    this.uiComponents.skills.unselectAll();
                }
                this._onSkillsChange();
                this.ui.skillsContainer.toggleClass("hide", !status);
                this.uiComponents.skills.setEnabled(this.hasAgentUserEditPrivilege);
            },

            _updateSkillItems: function() {
                if (this.uiComponents.skills) {
                    this.uiComponents.skills.setItems(this._getSkillsItems());
                }
            },

            _updateSkillsMismatch: function() {
                if (this.hasTaggingByLobFeatureEnabled) {
                    var isMismatch = this.model.isMismatchLobsAndSkills(this.skillsCollection);
                    this.ui.skillsMismatch.toggleClass("hide",!isMismatch);
                }
            },

            manageManagerOfFieldStatus: function(status) {
                if (status) {
                    this.ui.managerOfSelectContainer.removeClass("hide");
                } else {
                    this.ui.managerOfSelectContainer.addClass("hide");
                }
                this.uiComponents.manageGroups.setEnabled(this.hasAgentManagerUserEditPrivilege);
            },

            employeeIdStatus: function(status) {
                this.ui.employeeIdContainer.toggleClass("hide", status);
            },

            manageMemberOfFieldStatus: function(status) {
               if (status) {
                   var memberOfValue = this._isMemberOf();
                  if (memberOfValue) {
                      this.uiComponents.memberSingleSelect.setInputValue(memberOfValue);
                  }
                   this.ui.memberOfSelectContainer.removeClass("hide");
                   this.listenTo(this.uiComponents.memberSingleSelect, SingleSelect.TRIGGERING.INPUT_CHANGE, this._onGroupInputChange);
                   this.listenTo(this.uiComponents.memberSingleSelect, SingleSelect.TRIGGERING.CHANGE, this._onGroupSelect);
                   this.isMemberSingleSelectInputChanged = false;
                   this.listenTo(this.uiComponents.memberSingleSelect, SingleSelect.TRIGGERING.BLUR, this._onGroupBlur);
               } else {
                   this.stopListening(this.uiComponents.memberSingleSelect, SingleSelect.TRIGGERING.INPUT_CHANGE);
                   this.stopListening(this.uiComponents.memberSingleSelect, SingleSelect.TRIGGERING.CHANGE);
                   this.stopListening(this.uiComponents.memberSingleSelect, SingleSelect.TRIGGERING.BLUR);
                   this.ui.memberOfSelectContainer.addClass("hide");
               }
                this.uiComponents.memberSingleSelect.setEnabled(this.hasAgentUserEditPrivilege);
            },

            _updateApiKeysCollection: function() {
                if (this.uiComponents.apiKeysDropdown) {
                    var filteredApiKeysCollection = this._filterApiKeysCollection();
                    this.apiKeysCollection.add(filteredApiKeysCollection.models);
                    var selectedApiKey = this._getSelectedApiKey();
                    this.uiComponents.apiKeysDropdown.setSelection(selectedApiKey);
                    this.uiComponents.apiKeysDropdown.setEnabled(true);
                    this._updateApiKeyDetails(selectedApiKey);
                }
            },

            _isMemberOf: function() {
                var memberOf = this.model.getMemberOfGroup();

                if (memberOf) {
                    var groupCollection = this._getGroupsItems();
                    _.each(groupCollection, function(group){
                        if (group.id === memberOf){
                            memberOf = group.value;
                            return;
                        }
                    });
                    return memberOf;
                } else {
                    return null;
                }
            },

            _setFocus: function() {
                var focusedComponent = (this.model.isNew()) ? this.uiComponents.loginName : this.uiComponents.email;
                focusedComponent.setFocus(true);
            },
            _renderUserType: function() {
                if (LE.sessionManager.hasUserTypeBotFeature()){
                    this.ui.userTypeContainer.removeClass("hide");
                    this.uiComponents.host$.createAndRender("userType", {
                        type: Dropdown,
                        options: {
                            container: "view.ui.userType",
                            permutation: Dropdown.PERMUTATION.MEDIUM,
                            items: "view._getUserTypes",
                            selectedOption: "view.model.getUserType",
                            enabled: "view._getUserTypeState"
                        },
                        events: {
                            change: "_onUserTypeChange"
                        }
                    });
                }
            },
            _getUserTypeState: function() {
                return this.model.isNew() && LE.sessionManager.hasPrivilege(LE.sessionManager.PRIVILEGES.VIEW_API_KEYS_MANAGEMENT);
            },
            _updateLoginName: function() {
                this.uiComponents.loginName.setValue(this.model.getLoginName());
                if (!this.model.isNew()) {
                    this.uiComponents.loginName.setEnabled(false);
                }
            },
            _updateEmail: function() {
                this.uiComponents.email.setValue(this.model.getEmail());
            },
            _updateNickName: function() {
                this.uiComponents.nickName.setValue(this.model.getNickName());
            },
            _updateDisplayName: function() {
                this.uiComponents.displayName.setValue(this.model.getDisplayName());
            },

            _updatePictureUrl: function() {
                var pictureUrl = this.model.getPictureUrl();
                if (!pictureUrl) {
                    pictureUrl = "";
                }
                this.uiComponents.pictureUrl.setValue(pictureUrl);
                if (pictureUrl === "") {
                    if (this.model.getUserType() === this.model.USER_TYPES.BOT){
                        this.ui.picturePreview.attr("src", URLS.BOT_PICTURE);
                    }
                    else {
                        this.ui.picturePreview.attr("src", URLS.AVATAR_PICTURE);
                    }
                } else {
                    this.ui.picturePreview.attr("src", pictureUrl);
                }
            },
            _updateEnabled: function() {
                this.uiComponents.enabled.setChecked(this.model.getEnabled());
                if (this.isMyUser) {
                    this.uiComponents.enabled.setEnabled(false);
                }
            },
            _updateMaxChats: function() {
                this.uiComponents.maxChats.setSelection(this.model.getMaxNumberOfChats());
            },
            _updateChangePasswordNextLogin: function() {
                this.uiComponents.changePasswordNextLogin.setChecked(this.model.getChangePasswordNextLogin());
                if (this.isMyUser) {
                    this.uiComponents.changePasswordNextLogin.setEnabled(false);
                    this.ui.changePasswordContainer.addClass("hide");
                }
            },

            _onLoginNameChange: function(componentId, eventName, loginName) {
                this.channel.trigger("user:change:loginName", loginName);
            },
            _onEmailChange: function(componentId, eventName, email) {
                this.channel.trigger("user:change:email", email);
            },

            _onNickNameChange: function(componentId, eventName, nickName) {
                this.channel.trigger("user:change:nickName", nickName);
            },

            _onDisplayNameChange: function(componentId, eventName, displayName) {
                this.channel.trigger("user:change:displayName", displayName);
            },

            _onEmployeeIdChange: function(componentId, eventName, employeeId) {
                this.channel.trigger("user:change:employeeId", employeeId);
            },

            _onPictureUrlBlur: function(componentId, eventName, obj) {
                this.blurTimeout = setTimeout(_.bind(function(){
                    this.channel.trigger("user:blur:pictureUrl", {value: obj, origin: "fieldBlur"});
                }, this), 200);
             },

            _getProfilesArray: function() {
                var profilesArr = [];
                this.profilesCollection.each(function(profileModel) {
                    var roleTypeId = profileModel.getRoleTypeId().toString();
                    var selected = _.include(this.model.getProfiles() || [], profileModel.id);

                    // the profile is enabled if the user has no specific privilege, or the role of the profile match the specific privileges
                    var isProfileEnabled = false;
                    if (LEUserManagement.hasAllUsersViewPrivilege() ||
                        (LEUserManagement.hasAgentUserEditPrivilege() && roleTypeId === ProfileModel.ROLES.AGENT) ||
                        (LEUserManagement.hasAgentManagerUserEditPrivilege() && roleTypeId === ProfileModel.ROLES.AGENT_MANAGER)) {
                        isProfileEnabled = true;
                    }

                    var role = LE.translator.translate(ProfileModel.ROLES_BY_IDS[roleTypeId]);
                    var tooltip = "";
                    if (isProfileEnabled) {
                        tooltip = LE.translator.translate({
                            key: "LEUserManagement.userEdit.profiles.role.tooltip",
                            args: [{key: role, isTranslate: false}]
                        });
                    }
                    else {
                        tooltip = LE.translator.translate("LEUserManagement.userEdit.profiles.role.tooltip.noPermission");
                    }

                    if (selected || isProfileEnabled) {
                        profilesArr.push({
                            id: profileModel.id,
                            value: profileModel.getName(),
                            group: role,
                            tooltip: tooltip,
                            selected: _.include(this.model.getProfiles() || [], profileModel.id),
                            enabled: isProfileEnabled
                        });
                    }
                }, this);

                return profilesArr;
            },

            _getRolesArray: function() {
                var rolesArr = [];
                this.profilesCollection.each(function(profileModel) {
                    var roleId = profileModel.getRoleTypeId();
                    if (-1 === rolesArr.indexOf(roleId)) {
                        rolesArr.push(profileModel.getRoleTypeId());
                    }
                }, this);

                return rolesArr.sort();
            },

            _onProfileChange: function() {
                var profiles = this.uiComponents.profile.getSelectedItems();
                this.channel.trigger("user:change:profile", profiles || []);
            },

            _onProfileSelect: function(componentId, eventName, item) {
                this._onProfileChange();
            },

            _onProfileUnSelect: function(componentId, eventName, item) {
                this._onProfileChange();
            },

            _onPictureUrlChange: function(componentId, eventName, obj) {
                this.channel.trigger("user:change:pictureUrl");
            },

            _onEnabledChange: function(componentId, eventName, enabled) {
                this.channel.trigger("user:change:enabled", enabled);
            },
            _onIsApiUserChange: function(componentId, eventName, obj) {
                var resetAll = obj.selectedKey === null;
                if (obj.selectedKey === IS_API_USER_KEYS.PASSWORD || resetAll){
                    this.uiComponents.apiKeysDropdown.setSelection(null, {silent: false});
                }
                if(obj.selectedKey === IS_API_USER_KEYS.API || resetAll){
                    this.uiComponents.newPassword.setValue("", {silent: false});
                    this.uiComponents.retypePassword.setValue("", {silent: false});
                }
                this.channel.trigger("user:change:isApiUser", obj.selectedKey);
            },
            _onUserTypeChange: function(componentId, eventName, obj) {
                if(this.uiComponents.isApiUser && this.model.getUserType() !== obj.selectedKey){
                    this.uiComponents.isApiUser.setSelection(null, {silent: false});
                }
                this.channel.trigger("user:change:userType", obj.selectedKey);
            },
            _onApiKeyChange: function(componentId, eventName, apiKeyObj) {
                if (apiKeyObj.selectedKey === CREATE_API_KEY_ID) {
                    this.channel.trigger("user:click:create:apiKey");
                }
                else {
                    this.channel.trigger("user:change:apiKey", apiKeyObj.selectedKey);
                }
            },
            _updateApiKeyDetails: function() {
                var appKey = this.model.getAllowedAppKeys();
                if (!_.isEmpty(appKey)) {
                    var apiKeyModel = this.apiKeysCollection.get(appKey);
                    if (!_.isEmpty(apiKeyModel)) {
                        this.ui.appKey.text(appKey);
                        this.ui.appSecret.text(apiKeyModel.getApiKeySecret());
                        this.ui.accessToken.text(apiKeyModel.getAccessToken());
                        this.ui.accessTokenSecret.text(apiKeyModel.getAccessTokenSecret());
                    }
                    this.ui.apiDetailsContainer.toggleClass("hide", _.isEmpty(apiKeyModel));
                }
                this._showApiErrorIcon(appKey);
            },
            _getApiKeysCollection: function() {
                this.apiKeysCollection = this._filterApiKeysCollection();
                return this.apiKeysCollection;
            },
            _filterApiKeysCollection: function() {
                var filteredApiArray = [];
                if (LE.sessionManager.hasUserTypeBotFeature()) {
                    var apiCollection = LEUserManagement.getDataManager().getApiKeysCollection();
                    var selectedAppKey = this.model.getAllowedAppKeys();
                    filteredApiArray = apiCollection.filter(function (model) {
                        var hasPrivilege = _.some(model.getPrivileges(), function(privilege) {
                            return privilege.data === API_KEY_MODEL_PRIVILEGE.data;
                        });
                        return model.getApiKey() === selectedAppKey || (model.isActive() && hasPrivilege);
                    });
                }
                return new Backbone.Collection(filteredApiArray);
            },
            _getApiKeyCustomItem: function() {
                return {
                    key:CREATE_API_KEY_ID,
                    value:LE.translator.translate("LEUserManagement.userEdit.apiKeys.dropdown.createApiKey.label"),
                    cssClass:"createApiKeyLink"
                };
            },
            _onApiCreateSuccess: function(apiModel) {
                this.apiKeysCollection.add(apiModel);
                if (this.uiComponents.apiKeysDropdown) {
                    this.uiComponents.apiKeysDropdown.setSelection(apiModel.getApiKey(), {silent:false});
                }
            },
            _onApiCreateError: function() {
                var selection = null;
                if (!_.isEmpty(this.model.getAllowedAppKeys())) {
                    selection = this.model.getAllowedAppKeys();
                }
                if (this.uiComponents.apiKeysDropdown) {
                    this.uiComponents.apiKeysDropdown.setSelection(selection);
                }
            },
            _getSelectedApiKey: function() {
                var appKeyFromModel = this.model.getAllowedAppKeys();
                return (!_.isEmpty(appKeyFromModel) && this.apiKeysCollection.size() !== 0) ? appKeyFromModel : null;
            },
            _showApiErrorIcon: function(appKey) {
                var apiModel = !_.isNull(appKey) ? this.apiKeysCollection.get(appKey) : null;
                var hasApiPrivilege = true;
                var isActive = true;
                if (!_.isNull(apiModel) && !_.isUndefined(apiModel)) {
                    hasApiPrivilege = _.some(apiModel.getPrivileges(), function (privilege) {
                        return privilege.data === API_KEY_MODEL_PRIVILEGE.data;
                    });
                    isActive = apiModel.isActive();
                }
                if (!hasApiPrivilege) {
                    this.apiErrorIconMsg = LE.translator.translate("LEUserManagement.userEdit.appKey.noPrivilege.error.tooltip");
                }
                if (!isActive) {
                    this.apiErrorIconMsg = LE.translator.translate("LEUserManagement.userEdit.appKey.notActive.error.tooltip");
                }
                var fetchSuccess = LEUserManagement.getDataManager().getApiKeysCollection().hasAtLeastOneSuccessfulFetch();
                if (!fetchSuccess) {
                    this.apiErrorIconMsg = LE.translator.translate("LEUserManagement.userEdit.apiCollection.fetch.error.tooltip");
                }
                var showApiErrorIcon = !fetchSuccess || !hasApiPrivilege || !isActive;
                var showApiKeyDisabledIcon = !fetchSuccess || isActive;
                this.ui.apiErrorIcon.toggleClass("hide", !showApiErrorIcon);
                this.ui.apiErrorIcon.toggleClass("not-active", !showApiKeyDisabledIcon);
            },
            _getApiKeysDropdownState: function() {
                var apiKeysCollectionFetched = LEUserManagement.getDataManager().getApiKeysCollection().hasAtLeastOneSuccessfulFetch() && LE.sessionManager.hasPrivilege(LE.sessionManager.PRIVILEGES.VIEW_API_KEYS_MANAGEMENT);
                return apiKeysCollectionFetched;
            },

            _onMaxChatsChange: function(componentId, eventName, obj) {
                this.channel.trigger("user:change:maxNumberOfChats", obj.selectedKey);
            },

            _onSkillsCreate: function(componentId, eventName, obj) {
                this.uiComponents.skills.discardInput();
                this.channel.trigger("user:skill:create", obj.value);
            },

            _onSkillCreateSuccess: function(skillModel) {
                this.uiComponents.skills.discardInput();
                this.uiComponents.skills.addItem({
                    id: skillModel.id,
                    value: skillModel.getName(),
                    selected: true
                });
                this.uiComponents.skills.setFocus();
                this._onSkillsChange();
            },

            _onSkillCreateError: function(errorObject, skillName) {
                // this on defer because we need to make sure we blur the input and remove the inline error after it blurs.
                _.defer(_.bind(function () {
                    this.uiComponents.skills.setBlur();
                    this.uiComponents.skills.setInlineError(false);
                }, this));

                if (!_.isEmpty(errorObject)) {
                    var errors = {};
                    errors[this.model.getKeys().SKILLS] = _.values(errorObject)[0];
                    this._setErrors(errors);
                }
            },

            _onSkillsChange: function(componentId, eventName, item) {
                var skills = this.uiComponents.skills.getSelectedItems();
                this.channel.trigger("user:change:skills", skills);
                this._updateSkillsMismatch();
            },

            _onLobsChange: function(componentId, eventName, item) {
                var lobs = this.uiComponents.lobs.getSelectedItems();
                this.channel.trigger("user:change:lobs", lobs);
                this._updateSkillItems();
                this._updateSkillsMismatch();
            },

            _onGroupSelect: function(data) {
                this.channel.trigger("user:change:memberSingleSelect", data.item.id);
            },

            _onManagerChange: function(componentId, eventName, item) {
                this.channel.trigger("user:change:managerOfGroups", item);
            },

            _onCurrentPasswordChange: function(componentId, eventName, password) {
                this.channel.trigger("user:change:oldPassword", password);
            },

            _onNewPasswordChange: function(componentId, eventName, password) {
                this.channel.trigger("user:change:password", password);
            },

            _onRetypePasswordChange: function(componentId, eventName, password) {
                this._updateSaveButtonState({valueChanged:true});
            },
            _onChangePasswordNextLoginChange: function(componentId, eventName, changePwdNextLogin) {
                this.channel.trigger("user:change:changePasswordNextLogin", changePwdNextLogin);
            },

            _onModelChange: function() {
                this._updateSaveButtonState({valueChanged:true});
            },

            _showPictureUrlBubble: function() {
                this._closePictureUrlBubble(null, true);
                this.uiComponents.host$.createAndRender("pictureUrlBubble", {
                    type: Bubble,
                    options: {
                        targetControl: this.ui.pictureUrlIcon,
                        position: Bubble.POSITION.RIGHT,
                        showCloseButton: false,
                        isDelayed: true,
                        contentView: new PictureUrlBubbleView()
                    }
                });
            },

            _showProfileBubble: function() {
                this._closeProfileBubble(null, true);
                this.uiComponents.host$.createAndRender("profileBubble", {
                    type: Bubble,
                    options: {
                        targetControl: this.ui.profileIcon,
                        position: Bubble.POSITION.RIGHT,
                        showCloseButton: false,
                        isDelayed: true,
                        contentView: new ProfileBubbleView({ profiles: this._getRolesArray() })
                    }
                });
            },

            _closeProfileBubble: function(event, force) {
                if (this.uiComponents.profileBubble) {
                    this.uiComponents.profileBubble.close(force);
                }
            },

            _showUserTypeBubble: function(event) {
                this._closeUserTypeBubble(event, true);
                this.uiComponents.host$.createAndRender("userTypeBubble", {
                    type: Bubble,
                    options: {
                        targetControl: this.ui.userTypeIcon,
                        position: Bubble.POSITION.RIGHT,
                        showCloseButton: false,
                        isDelayed: true,
                        text: LE.translator.translate("LEUserManagement.userEdit.userType.tooltip")
                    }
                });
            },

            _closeUserTypeBubble: function(event, force) {
                if (this.uiComponents.userTypeBubble) {
                    this.uiComponents.userTypeBubble.close(force);
                }
            },

            _showAuthBubble: function(){
                this._closeAuthBubble(null, true);
                this.uiComponents.host$.createAndRender("authBubble", {
                    type: Bubble,
                    options: {
                        targetControl: this.ui.apiSubSectionIcon,
                        position: Bubble.POSITION.RIGHT,
                        showCloseButton: false,
                        isDelayed: true,
                        contentView: new AuthDetailsBubbleView()
                    }
                });
            },

            _closeAuthBubble: function(event, force){
                if (this.uiComponents.authBubble) {
                    this.uiComponents.authBubble.close(force);
                }
            },

            _showApiErrorBubble: function(){
                this._closeApiErrorBubble(null, true);
                this.uiComponents.host$.createAndRender("apiErrorBubble", {
                    type: Bubble,
                    options: {
                        targetControl: "view.ui.apiErrorIcon",
                        position: Bubble.POSITION.RIGHT,
                        showCloseButton: false,
                        isDelayed: true,
                        text: this.apiErrorIconMsg
                    }
                });
            },

            _closeApiErrorBubble: function(event, force){
                if (this.uiComponents.apiErrorBubble) {
                    this.uiComponents.apiErrorBubble.close(force);
                }
            },

            _renderMaxConversationsRadioButtonList: function() {
                if (this.showMaxConversations) {
                    this.ui.maxConversationsContainer.removeClass("hide");
                    this.uiComponents.host$.createAndRender("maxConversationRadioButtonList", {
                        type: RadioButtonList,
                        options: {
                            el: "view.ui.maxConversationRadioButtonList",
                            items: "view._getMaxConversationRadioButtonItems",
                            permutation: RadioButtonList.PERMUTATION.D,
                            defaultSelection: "view._getSelectedMaxConversationOption"
                        },
                        events: {
                            change: "_onMaxConversationRadioButtonListChange"
                        }
                    });

                    this._toggleMaxConversationCustomInput();
                }
            },

            _getSelectedMaxConversationOption: function() {
                var userModelMaxConversationSettings = this.model.getMaxConversations();
                var selectedOption = (_.isNull(userModelMaxConversationSettings)) ? MAX_CONVERSATIONS_TYPE.ACCOUNT_SETTINGS :
                    MAX_CONVERSATIONS_TYPE.CUSTOM_SETTINGS;

                return selectedOption;
            },

            _onMaxConversationRadioButtonListChange: function() {
                if(this.uiComponents.maxConversationRadioButtonList.getSelectedKey() === MAX_CONVERSATIONS_TYPE.ACCOUNT_SETTINGS) {
                    this.channel.trigger("user:change:maxConversations", null);
                    this.userEditMaxConversationsCustomView.clearCustomConfigurationInputField();
                }
                this._toggleMaxConversationCustomInput();
                this._updateSaveButtonState({valueChanged:true});

            },

            _getMaxConversationRadioButtonItems: function () {
                this.userEditMaxConversationsAccountView = new UserEditMaxConversationsAccountView({maxConversationsSettings: this.maxConversationsSettings});
                this.userEditMaxConversationsCustomView = new UserEditMaxConversationsCustomView({model: this.model, channel: this.channel});
                var items =[
                    {
                        key: MAX_CONVERSATIONS_TYPE.ACCOUNT_SETTINGS,
                        embeddedView: this.userEditMaxConversationsAccountView
                    },
                    {
                        key: MAX_CONVERSATIONS_TYPE.CUSTOM_SETTINGS,
                        embeddedView: this.userEditMaxConversationsCustomView
                    }
                ];
                return items;
            },

            _toggleMaxConversationCustomInput: function () {
                var showCustomInput = (this.uiComponents.maxConversationRadioButtonList.getSelectedKey() === MAX_CONVERSATIONS_TYPE.CUSTOM_SETTINGS);
                this.userEditMaxConversationsCustomView.showCustomConfigurationInputField(showCustomInput);
            },


            _closePictureUrlBubble: function(event, force) {
                if (this.uiComponents.pictureUrlBubble) {
                    this.uiComponents.pictureUrlBubble.close(force);
                }
            },

            _updateSaveButtonState: function(options) {
                options = options || {};
                var isSaveEnabled = this.model.validateSaveEnabled() && this._validateViewSaveEnabled();

                if (!isSaveEnabled) {
                    this.uiComponents.saveButton.setEnabled(false);
                    var mandatoryFieldsErrorKey = (this.model.isNew()) ? "newUser" : "editUser";
                    this.uiComponents.saveButton.setTooltip(LE.translator.translate("LEUserManagement.userEdit.saveButton.tooltip.mandatoryFields." + mandatoryFieldsErrorKey));
                }
                else {
                    if (options.valueChanged) {
                        this.uiComponents.saveButton.setEnabled(true);
                        this.uiComponents.saveButton.setTooltip("");
                    }
                    else {
                        this.uiComponents.saveButton.setEnabled(false);
                        this.uiComponents.saveButton.setTooltip(LE.translator.translate("LEUserManagement.userEdit.saveButton.tooltip.noChanges"));
                    }
                }
            },

            // change the loop inside a loop
            _getAgentGroups: function() {
                var agentGroupsArr;
                var currentManagerOfGroupsArr = _.map(this.model.getManagerOfGroup(), "agentGroupId");

                if (LEUserManagement.hasAllUsersViewPrivilege()) {
                    agentGroupsArr = this.agentGroupsCollection.map(function(groupModel){
                        return {
                            id: groupModel.id,
                            value: groupModel.getName(),
                            selected: _.contains(currentManagerOfGroupsArr, groupModel.id)
                        };
                    });
                }
                else {
                    var dataManager = LEUserManagement.getDataManager();
                    var groupsUnderLoggedInUser = dataManager.getData(dataManager.getEntities().AGENT_MANAGER_MODEL).getGroups();
                    var mergedGroups = groupsUnderLoggedInUser.concat(currentManagerOfGroupsArr);
                    agentGroupsArr = _.map(mergedGroups, _.bind(function(groupId) {
                        var groupModel = this.agentGroupsCollection.get(groupId);
                        return {
                            id: groupModel.id,
                            value: groupModel.getName(),
                            selected: _.contains(currentManagerOfGroupsArr, groupModel.id),
                            enabled: _.contains(groupsUnderLoggedInUser, groupModel.id)
                        };
                    }, this));
                }

                return agentGroupsArr;
            },
            _getIsApiUserItems: function() {
                var isApiUsersArr = [{
                        key: IS_API_USER_KEYS.PASSWORD,
                        value: LE.translator.translate("LEUserManagement.userEdit.loginMethod.password")
                    },
                    {
                        key: IS_API_USER_KEYS.API,
                        value: LE.translator.translate("LEUserManagement.userEdit.loginMethod.api")
                    }];
                return new Dropdown.Collection(isApiUsersArr);
            },
            _getUserTypes: function() {
                var that = this;
                var userTypes = this.model.USER_TYPES;
                if(!_.contains(userTypes, this.model.getUserType())){
                    userTypes = _.extend({UNKNOWN: this.model.getUserType()}, this.model.USER_TYPES);
                }
                var userTypesArr = _.map(userTypes, function(typeId){
                    return {key: typeId, value:LE.translator.translate("LEUserManagement.userEdit.userType." + that.model.getUserTypeKey(typeId))};
                });

                return new Dropdown.Collection(userTypesArr);
            },
            _getMaxChatsItems: function() {
                var maxChatsArr = [];
                maxChatsArr.push({
                    key: this.model.MAX_CHATS_CONST.NO_CHATS,
                    value: LE.translator.translate("LEUserManagement.userEdit.maxChats.noChats.label")
                });
                _.each(_.range(1,11), function(number){
                    maxChatsArr.push({key:number.toString(), value:number.toString()}); // we "toString" it because the value in the userModel is saved as a string
                });
                maxChatsArr.push({
                    key: this.model.MAX_CHATS_CONST.UNLIMITED,
                    value: LE.translator.translate("LEUserManagement.userEdit.maxChats.unlimited.label")
                });

                return new Dropdown.Collection(maxChatsArr);
            },

            _getSkillsItems: function() {
                var skillsArr = [];

                var userLobs = this.model.getLobs();
                this.skillsCollection.each(function(skillModel){
                    var skillLobs = skillModel.getLobs();
                    var isSkillSelected = _.include(this.model.getSkills(), skillModel.id);
                    var isSkillAllowed = !this.hasTaggingByLobFeatureEnabled || LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.isSkillAllowedForSelection, skillLobs, userLobs);
                    if (isSkillAllowed || isSkillSelected) {
                        skillsArr.push({
                            id: skillModel.id,
                            value: skillModel.getName(),
                            selected: isSkillSelected
                        });
                    }
                }, this);

                return skillsArr;
            },

            _getLobsItems: function() {
                var lobsCollection = LEUserManagement.getDataManager().getLobsCollection();
                var lobsArr = [];

                lobsCollection.each(function(lobModel){
                    var isLobAllowed = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.isLobAllowedForUser, lobModel.id);
                    var isLobSelected = (_.indexOf(this.model.getLobs(), lobModel.id) > -1);
                    if (isLobAllowed || isLobSelected) {
                        lobsArr.push({
                            id: lobModel.id,
                            value: lobModel.getName(),
                            selected: isLobSelected,
                            enabled: isLobAllowed
                        });
                    }
                }, this);

                return lobsArr;
            },

            _getGroupsItems: function() {
                var agentGroupsArr;
                var currentMemberOfGroupArr = (this.model.getMemberOf()) ? [this.model.getMemberOf().agentGroupId] : [];

                if (LEUserManagement.hasAllUsersViewPrivilege()) {
                    agentGroupsArr = this.agentGroupsCollection.map(function(group) {
                        return {
                            id: group.id,
                            value: group.getName()
                        };
                    });
                }
                else {
                    var dataManager = LEUserManagement.getDataManager();
                    var groupsUnderLoggedInUser = dataManager.getData(dataManager.getEntities().AGENT_MANAGER_MODEL).getGroups();
                    var mergedGroups = groupsUnderLoggedInUser.concat(currentMemberOfGroupArr);
                    agentGroupsArr = _.map(mergedGroups, _.bind(function(groupId) {
                        var groupModel = this.agentGroupsCollection.get(groupId);
                        return {
                            id: groupModel.id,
                            value: groupModel.getName()
                        };
                    }, this));
                }

                return agentGroupsArr;
            },

            _getPasswordPlaceholder: function() {
                var passwordPlaceholder = (this.model.isNew() || this.isMyUser) ? "" : LE.translator.translate("LEUserManagement.userEdit.newPassword.placeholder");
                return passwordPlaceholder;
            },

            _validateViewSaveEnabled: function() {
                var isValid = true;
                var passwordIncomplete = _.isEmpty(this.uiComponents.newPassword.getValue()) || _.isEmpty(this.uiComponents.retypePassword.getValue());
                var appKeyIncomplete = this.uiComponents.apiKeysDropdown && _.isNull(this.uiComponents.apiKeysDropdown.getValue());
                if (this.model.isNew() && passwordIncomplete && appKeyIncomplete) {
                    isValid = false;
                }

                if (this.showMaxConversations && this.uiComponents.maxConversationRadioButtonList.getSelectedKey() === MAX_CONVERSATIONS_TYPE.CUSTOM_SETTINGS &&
                    _.isNull(this.model.getMaxConversations())){

                    isValid = false;
                }

                return isValid;
            },

            _onGroupBlur : function () {
                if( this.isMemberSingleSelectInputChanged) {
                    var memberObj = this.uiComponents.memberSingleSelect.getSelectedItem();  //todo: errors should be in model
                    if (_.isEmpty(memberObj)) {
                        this.uiComponents.memberSingleSelect.setError(true, LE.translator.translate("LEFramework.entities.user.errors.assignToGroup.notFromList"));
                        this.channel.trigger("user:change:memberSingleSelect", null);
                    } else {
                        this.channel.trigger("user:change:memberSingleSelect", memberObj.id);
                    }
                }
            },

            _validateView: function() {
                var errorsObj = {};

                if (this.model.getPassword() && this.uiComponents.retypePassword.getValue() !== this.model.getPassword())  {
                    errorsObj[RETYPE_PASSWORD_ERROR_KEY] = "LEUserManagement.userEdit.retypePassword.error.notMatch";
                }

                return errorsObj;
            },

            _onCancel: function() {
                clearTimeout(this.blurTimeout);
                this.channel.trigger("user:cancel");
            },

            _onSave: function() {
                this.channel.trigger("user:save", {origin: "save"});
            },

            _onSaveSuccess: function() {
                this._hideErrors();
            },

            _onSaveError: function(errors) {
                this._setErrors(errors);
            },

            _onGroupInputChange: function(value) {
                this.channel.trigger("user:change:memberSingleSelect", null);
                this.isMemberSingleSelectInputChanged = true;
            },

            _setErrors: function(errors) {
                this._hideErrors();

                this.errorsOnPage = errors;

                var keys = this.model.getKeys();
                var errorCodes = this.model.getErrorCodes();

                if (_.has(errors, keys.EMAIL_ADDRESS)) {
                    this.uiComponents.email.setError(true, errors[keys.EMAIL_ADDRESS]);
                }

                if (_.has(errors, keys.LOGIN_NAME)) {
                    this.uiComponents.loginName.setError(true, errors[keys.LOGIN_NAME]);
                }

                if (_.has(errors, keys.NICK_NAME)) {
                    this.uiComponents.nickName.setError(true, errors[keys.NICK_NAME]);
                }

                if (_.has(errors, keys.DISPLAY_NAME)) {
                    this.uiComponents.displayName.setError(true, errors[keys.DISPLAY_NAME]);
                }

                if (_.has(errors, RETYPE_PASSWORD_ERROR_KEY)) {
                    this.uiComponents.retypePassword.setError(true, errors[RETYPE_PASSWORD_ERROR_KEY]);
                    this.uiComponents.newPassword.setError(true, errors[RETYPE_PASSWORD_ERROR_KEY]);
                }

                if (_.has(errors, keys.PASSWORD)) {
                    this.uiComponents.newPassword.setError(true, errors[keys.PASSWORD]);
                }
                if (_.has(errors, keys.ALLOWED_APP_KEYS)) {
                    this.uiComponents.appKey.setError(true, errors[keys.ALLOWED_APP_KEYS]);
                }

                if (_.has(errors, keys.OLD_PASSWORD) && this.uiComponents.currentPassword) {
                    this.uiComponents.currentPassword.setError(true, errors[keys.OLD_PASSWORD]);
                }
                if (_.has(errors, keys.MEMBER_OF)) {
                    this.uiComponents.memberSingleSelect.setError(true, errors[keys.MEMBER_OF]);
                }
                if (_.has(errors, errorCodes.PASSWORD_RESTRICTIONS)) {
                    this.uiComponents.newPassword.setError(true, errors[errorCodes.PASSWORD_RESTRICTIONS]);
                }
                if (_.has(errors, keys.PICTURE_URL)) {
                    this.uiComponents.pictureUrl.setError(true, errors[keys.PICTURE_URL]);
                }
                if (_.has(errors, keys.INVALID_PICTURE_URL)) {
                    this.uiComponents.pictureUrl.setError(true, errors[keys.INVALID_PICTURE_URL]);
                }
                if (_.has(errors, keys.UNSUPPORTED_PICTURE_FORMAT)) {
                    this.uiComponents.pictureUrl.setError(true, errors[keys.UNSUPPORTED_PICTURE_FORMAT]);
                }

                if (_.has(errors, keys.SKILLS)) {
                    //var errorMethod = (_.isEmpty(this.uiComponents.skills.getInputValue())) ? "setError" : "setInlineError";
                    this.uiComponents.skills.setError(true, errors[keys.SKILLS]);
                }
            },

            _hideErrors: function () {
                this.errorsOnPage = null;
                this.uiComponents.loginName.setError(false);
                this.uiComponents.email.setError(false);
                this.uiComponents.nickName.setError(false);
                this.uiComponents.displayName.setError(false);
                if (this.uiComponents.appKey){
                    this.uiComponents.appKey.setError(false);
                }
                this.uiComponents.newPassword.setError(false);
                this.uiComponents.retypePassword.setError(false);
                if (this.uiComponents.currentPassword) {
                    this.uiComponents.currentPassword.setError(false);
                }
                this.uiComponents.memberSingleSelect.setError(false);
                this.uiComponents.pictureUrl.setError(false);
                if (this.uiComponents.skills) {
                    this.uiComponents.skills.setError(false);
                }
            },

            _hasProfiles: function () {
                return LE.sessionManager.hasProfilesFeature();
            }

            //</editor-fold>
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    return UserWithProfilesEditView;

});

